



































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import BaseMixin from "@/mixins/BaseMixin";
import Multiselect from "vue-multiselect";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import NavigationTabs from "@/components/Settings/Events/EventDetails/NavigationTabs.vue";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import WarningButton from "@/components/Common/Buttons/WarningButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import {
  EventType,
  IAudience,
  ICustomerGroup,
  IEvent,
  IInstructor
} from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    WarningButton,
    Multiselect,
    DatePicker,
    vueDropzone: vue2Dropzone,
    Error404
  }
})
export default class EventDetails extends Mixins(FormErrorsMixin, BaseMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "name",
    "short_name",
    "type",
    "bookability",
    "bookable_online",
    "bookable_from",
    "bookable_until",
    "start_date",
    "end_date",
    "freebie",
    "waitlist_enabled",
    "waitlist_max_places",
    "waitlist_autofill_free_places",
    "birthdate_mandatory",
    "max_participants",
    "online_max_participants",
    "disable_online_payment",
    "instructor_ids",
    "audience_ids"
  ];
  private noDataExist = false;
  private dateFormat = "DD.MM.YYYY";
  private dateTimeFormat = "DD.MM.YYYY HH:mm:ss";
  private readWriteAccess = true;
  private disableParticipantBirthdate = false;
  private courseAgeFormatted = true;
  private supportSchoolClass = true;
  private eventImageRemovable = true;
  private handleEventHost = true;
  private accountableByInstructor = true;
  private accountingBy = "instructor";
  private maxNumberOfFiles = 2;
  private originalName: string | null = null;
  private selectedEvent: IEvent = {
    name: null,
    short_name: null,
    type: null,
    bookability: false,
    bookable_online: false,
    bookable_from: null,
    bookable_until: null,
    start_date: null,
    end_date: null,
    freebie: false,
    waitlist_enabled: false,
    waitlist_max_places: null,
    waitlist_autofill_free_places: false,
    birthdate_mandatory: false,
    max_participants: null,
    online_max_participants: null,
    disable_online_payment: false,
    instructor_ids: [],
    audience_ids: []
  };
  private selectedEventId: string | null = null;
  private failedRequest = false;
  // Audiences
  private audienceValue: Array<IAudience> = [];
  private audienceOptions: Array<IAudience> = [];
  // Groups
  private groupValue: Array<ICustomerGroup> = [];
  private groupOptions: Array<ICustomerGroup> = [];
  // Event Types
  private eventTypes: Array<EventType> = [];
  // Instructors
  private instructorValue: Array<IInstructor> = [];
  private instructorOptions: Array<IInstructor> = [];
  private instructorSearchFilter = "";
  // Image
  private placeHolderUrl = require("@/assets/img/default-event.png");
  private url = require("@/assets/img/default-event.png");
  private newUrl: File | string | null = null;
  private originalEventImageUrl: string | null = null;
  private eventImage: File | null = null;
  // Dropzone for brochures
  private dropzoneOptions: any = {
    url: "https://httpbin.org/post",
    thumbnailWidth: 150,
    maxFilesize: 5,
    addRemoveLinks: true,
    uploadMultiple: false,
    parallelUploads: 1,
    maxFiles: 1,
    acceptedFiles: "application/pdf",
    dictDefaultMessage:
      '<i class="fa fa-cloud-upload"></i> Drop files here to upload',
    dictMaxFilesExceeded: "Max. number of uploads reached"
  };
  // Brochures
  private brochures: Array<File> = [];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedEventId = vm.$route.params.event_id;
      vm.getInstructors();
      vm.getAudiences();
      vm.getGroups();
      vm.getEventTypes();

      if (
        typeof vm.selectedEventId !== "undefined" &&
        vm.selectedEventId !== null
      ) {
        if (vm.$route.query.event_created) {
          swal("Success!", "The event was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getEvent(() => {
          //
        });
      } else {
        vm.newUrl = vm.placeHolderUrl;
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.getInstructors();
    this.getAudiences();
    this.getGroups();
    this.getEventTypes();

    if (
      typeof this.selectedEventId !== "undefined" &&
      this.selectedEventId !== null
    ) {
      this.getEvent(() => {
        //
      });
    } else {
      this.newUrl = this.placeHolderUrl;
    }
    next();
  }

  private onUploadBrochureFile(file: File): void {
    if (this.brochures.length < 2) {
      this.uploadEventBrochure(file);
    }
    // this.$refs.brochuresDropzone.removeFile(file);
  }

  private addGroup(group: ICustomerGroup): void {
    this.groupValue.push(group);
  }

  private addAudience(audience: IAudience): void {
    this.audienceValue.push(audience);
  }

  private addInstructor(instructor: IInstructor): void {
    this.instructorValue.push(instructor);
  }

  private createOrUpdateEvent(): void {
    if (this.selectedEventId == null) {
      this.createEvent();
    } else {
      this.updateEvent();
    }
  }

  private createEvent(): void {
    if (this.updating) {
      return;
    }
    this.resetErrors();

    if (this.instructorValue != null && this.instructorValue.length > 0) {
      for (let i = 0; i < this.instructorValue.length; i++) {
        this.selectedEvent?.instructor_ids?.push(this.instructorValue[i].id);
      }
    }

    if (this.audienceValue != null && this.audienceValue.length > 0) {
      for (let i = 0; i < this.audienceValue.length; i++) {
        this.selectedEvent?.audience_ids?.push(this.audienceValue[i].id);
      }
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("events");

    let startDate = this.selectedEvent.start_date;
    this.selectedEvent.start_date = this.convertDate(startDate) as Date;
    let endDate = this.selectedEvent.end_date;
    this.selectedEvent.end_date = this.convertDate(endDate) as Date;
    let bookableFrom = this.selectedEvent.bookable_from;
    this.selectedEvent.bookable_from = this.convertDateTime(
      bookableFrom
    ) as Date;
    let bookableUntil = this.selectedEvent.bookable_until;
    if (this.selectedEvent.bookable_until != null) {
      this.selectedEvent.bookable_until = this.convertDateTime(
        bookableUntil
      ) as Date;
    }

    Api()
      .post(endpoint, this.selectedEvent)
      .then((response: AxiosResponse) => {
        this.selectedEventId = response.data.data.id;
        if (
          this.originalEventImageUrl != this.url &&
          this.url != null &&
          this.url != this.placeHolderUrl
        ) {
          this.updateEventImage("create");
        } else {
          this.$router.push({
            name: "EventDetails",
            params: { event_id: `${this.selectedEventId}` },
            query: { event_created: "true" }
          });
        }
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#event-name", 500);
        this.selectedEvent.start_date = startDate;
        this.selectedEvent.end_date = endDate;
        this.selectedEvent.bookable_from = bookableFrom;
        this.selectedEvent.bookable_until = bookableUntil;
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getEvent(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedEvent = response.data.data;
        this.selectedEvent.start_date = this.convertDate(
          this.selectedEvent.start_date,
          response.data.data.start_date
        ) as Date;
        this.selectedEvent.end_date = this.convertDate(
          this.selectedEvent.end_date,
          response.data.data.end_date
        ) as Date;
        this.selectedEvent.bookable_from = this.convertDateTime(
          this.selectedEvent.bookable_from,
          response.data.data.bookable_from
        ) as Date;
        this.selectedEvent.bookable_until = this.convertDateTime(
          this.selectedEvent.bookable_until,
          response.data.data.bookable_until
        ) as Date;
        if (this.selectedEvent.name) {
          this.originalName = this.selectedEvent.name;
        }
        if (response.data.data.image != null) {
          this.url = response.data.data.image.url;
          this.originalEventImageUrl = this.url;
          this.newUrl = this.url;
        } else {
          this.newUrl = this.placeHolderUrl;
        }
        this.getEventBrochures();
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateEvent(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint = this.$partnerEndpoint("events/" + this.selectedEventId);

    let startDate = this.selectedEvent.start_date;
    this.selectedEvent.start_date = this.convertDate(startDate) as Date;
    let endDate = this.selectedEvent.end_date;
    this.selectedEvent.end_date = this.convertDate(endDate) as Date;
    let bookableFrom = this.selectedEvent.bookable_from;
    this.selectedEvent.bookable_from = this.convertDateTime(
      bookableFrom
    ) as Date;
    let bookableUntil = this.selectedEvent.bookable_until;
    if (this.selectedEvent.bookable_until != null) {
      this.selectedEvent.bookable_until = this.convertDateTime(
        bookableUntil
      ) as Date;
    }

    delete this.selectedEvent.image;

    Api()
      .put(endpoint, this.selectedEvent)
      .then(() => {
        if (
          this.originalEventImageUrl != this.url &&
          this.url != null &&
          this.url != this.placeHolderUrl
        ) {
          this.updateEventImage("update");
        } else {
          this.getEvent(() => {
            //
          });
        }
        swal({
          title: "Success!",
          text: "The event was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#event-name", 500);
        this.selectedEvent.start_date = startDate;
        this.selectedEvent.end_date = endDate;
        this.selectedEvent.bookable_from = bookableFrom;
        this.selectedEvent.bookable_until = bookableUntil;
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteEvent(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The event will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "events/" + this.selectedEventId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "Events",
              query: { event_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete events.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private updateEventImage(origin: string): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/image"
    );

    let formData = new FormData();
    if (this.eventImage != null) {
      formData.append("image", this.eventImage);
      formData.append("_method", "put");
    } else {
      return;
    }

    Api()
      .post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(() => {
        if (origin == "create") {
          this.$router.push({
            name: "EventDetails",
            params: { event_id: `${this.selectedEventId}` },
            query: { event_created: "true" }
          });
        }
        if (origin == "update") {
          swal({
            title: "Success!",
            text: "The event was updated.",
            icon: "success"
          });
        }
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#event-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getEventBrochures(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/brochures"
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.brochures = response.data.data;
        if (this.brochures.length >= 2) {
          // this.$refs.brochuresDropzone.disable();
        } else {
          // this.$refs.brochuresDropzone.enable();
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private uploadEventBrochure(brochureFile: File): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;

    let formData = new FormData();
    if (brochureFile != null) {
      formData.append("brochure", brochureFile);
      formData.append("_method", "post");
    } else {
      return;
    }

    const endpoint = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/brochures"
    );

    Api()
      .post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(() => {
        this.getEventBrochures();
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#event-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteEventBrochure(brochureId: number): void {
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/brochures/" + brochureId
    );

    Api()
      .delete(endpoint)
      .then(() => {
        this.getEventBrochures();
      })
      .catch((error: any) => {
        console.log(error.response);
        if (error.response.status === 403) {
          swal({
            title: "Missing permission",
            text: "You are not allowed to delete event brochures.",
            icon: "error"
            //dangerMode: true,
          });
        }
      });
  }

  private getAudiences(successCallback?: any): void {
    this.loading = true;
    this.audienceOptions = [];
    const endpoint: string = this.$partnerEndpoint("audiences");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.audienceOptions = response.data.data;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getGroups(successCallback?: any): void {
    this.loading = true;
    this.groupOptions = [];
    const endpoint: string = this.$partnerEndpoint("groups");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.groupOptions = response.data.data;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getEventTypes(successCallback?: any): void {
    this.loading = true;
    this.eventTypes = [];
    const endpoint: string = this.$partnerEndpoint("events/types");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.eventTypes = response.data.data;
        if (!this.selectedEventId) {
          this.selectedEvent.type = this.eventTypes[0];
        }
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getInstructors(successCallback?: any): void {
    this.instructorOptions = [];
    const endpoint: string = this.$partnerEndpoint("instructors");

    Api()
      .get(endpoint, {
        params: {
          page: 1,
          search: this.instructorSearchFilter
        }
      })
      .then((response: AxiosResponse) => {
        this.instructorOptions = response.data.data;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private onImageFileChange(e: any): void {
    const file = e.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    this.newUrl = URL.createObjectURL(file);
  }

  private onUpdateEventImage(): void {
    this.url = this.newUrl;
    // this.eventImage = this.$refs.eventImage.files[0];
  }

  private onDeleteEventImage(): void {
    // this.deleteEventImage();
  }

  private updateInstructorSearchFilter(search: string): void {
    this.instructorSearchFilter = search;
    this.getInstructors(() => {
      //
    });
  }
}
